module.exports = __webpack_public_path__ + "img/Nathaniel Ledbetter.c2871b54.jpg";